import { Box, Select } from '@chakra-ui/react'
import type { FieldError, FieldValues } from 'BrokerTsLib/src/rhf'
import { InputGroup } from './InputGroup'

export const PhoneInputGroup = ({ select, input, errors }: { select?: FieldValues; input: FieldValues, errors?: FieldError | undefined }) => {

  return (
    <Box
      sx={{
        display: 'grid',
        gridTemplateColumns: 'auto auto',
        placeContent: 'start',
        placeItems: 'start',
        gap: 2,
      }}
    >
      {select && <Select {...select}>
        {['+420', '+421']
          .map((prefix) => {
            return (
              <option key={prefix} value={prefix}>
                {prefix}
              </option>
            )
          })}
      </Select>}

      <InputGroup
        inputMode="tel"
        placeholder="Telefonní číslo"
        pattern="[\+0-9\s]+"
        htmlSize={10}
        errors={errors}
        {...input}
      />
    </Box>
  )
}